import React from 'react'
import { Grid } from '@material-ui/core'
import { useStyles } from './Styles'
import { FormattedMessage } from 'react-intl'
import { PlanConsumer } from '../../../../PlanContext'
import PageTitle from '../../PageTitle/PageTitle'
import { FormLoader } from '../../../Loader/FormLoader'
import Alert from '@material-ui/lab/Alert'
import PlanForm from './PlanForm'
import { NamedRoutes } from '../../../../routes'
import BreadCrumb from '../../BreadCrumb'

const PlanEditContent = ({ pageTitle }) => {
  const classes = useStyles()
  return (
    <>
      <BreadCrumb links={[
        {
          key: 'BreadcrumbLink-1',
          name: <FormattedMessage id='Sidebar.Links.Plans'/>,
          link: NamedRoutes.subscription.plan.list
        }
      ]} current={pageTitle ?? <FormattedMessage id='Plans.List.AddPlan.Title'/>}/>
      <PageTitle title={pageTitle ?? <FormattedMessage id='Plans.List.AddPlan.Title'/>}/>
      <Grid container spacing={4}>
        <Grid item xs={12} className={classes.EditProfileContentContainer}>
          <div className={classes.EditProfileContent}>
            <PlanConsumer>
              {({ planDataLoading, planDataFailure, planData, handlePlanSubmit, pageAction, servicesList }) => (
                <>
                  {!!planDataLoading && <FormLoader loading={true}/>}
                  {!!planDataFailure &&
                  <Alert severity="error"><FormattedMessage id='UpdateProfile.FormErrorAlert'/></Alert>
                  }
                  {pageAction === 'add' ?
                    <PlanForm currentDate={{}} onSubmit={handlePlanSubmit} servicesList={servicesList}/> :
                    (!!planData && !!Object.keys(planData).length &&
                      <PlanForm currentDate={planData} onSubmit={handlePlanSubmit} servicesList={servicesList}/>)
                  }
                </>
              )}
            </PlanConsumer>
          </div>
        </Grid>
      </Grid>
    </>
  )
}

export default PlanEditContent
